export interface Bonus {
  number: number
  name: string
  value: string
  included: boolean
  image: string
  description: string
  items: string[]
  benefit: string
}

export interface Testimonial {
  type: 'text' | 'screenshot' | 'video'
  name: string
  city: string
  quote: string
  stars: number
  photo: string
  media: string
}

export const salesPageData = {
  brand: 'La Bóveda del Carpintero',
  productName: 'La Bóveda del Carpintero',
  tagline:
    'Planos, medidas, proyectos y recursos para tener siempre qué fabricar.',
  promise: 'Tu próximo proyecto ya está adentro.',
  secondaryPromise: 'Abrí la Bóveda y elegí qué vas a fabricar.',
  subtitle:
    'Desbloqueá más de 500 planos, medidas, diseños y proyectos de carpintería organizados en una sola biblioteca digital para dejar de perder horas buscando qué fabricar y empezar cada nuevo proyecto con una referencia clara, incluso si estás empezando desde cero.',
  website: '[AGREGAR DOMINIO]',
  supportEmail: '[AGREGAR CORREO DE SOPORTE]',
  mainMockup:
    'https://cdn.magicpatterns.com/uploads/qGnzgFNZYxHFnaB8h8tjKc/ChatGPT_Image_2_ago_2026,_04_38_58_p.m.png',
  checkoutUrl: '',
  promotionalPrice: '$19.990',
  currency: 'ARS',
  referenceValue: '$144.000',
  regularPrice: '',
  guaranteeDays: 7,
  access: 'Ilimitado',
  paymentType: 'Pago único',
  deliveryMethod: '[AGREGAR MÉTODO REAL DE ENTREGA]',
  paymentMethods: [] as string[],
  promoDeadline: '',
  promoCondition: '',
  mainProduct: {
    name: 'Bóveda Principal',
    projects: '500+',
    referenceValue: '$39.000',
    description: '500+ planos y proyectos.',
  },
  bonuses: [
    {
      number: 1,
      name: 'Carpintería Desde Cero',
      value: '$12.000',
      included: true,
      image:
        'https://cdn.magicpatterns.com/patterns/generated-images/655bd4b3-e9b2-4d18-a872-85db3582fb09.jpg',
      description:
        'Una guía para quienes todavía están dando sus primeros pasos y necesitan entender las bases antes de avanzar.',
      items: [
        'Qué herramientas comprar primero.',
        'Cómo medir y marcar.',
        'Principios básicos de corte.',
        'Errores frecuentes.',
        'Proyectos para comenzar.',
      ],
      benefit:
        'Empezá con una ruta mucho más clara aunque hoy tengas poca experiencia.',
    },
    {
      number: 2,
      name: 'Melamina Pro',
      value: '$15.000',
      included: true,
      image:
        'https://cdn.magicpatterns.com/patterns/generated-images/7be45a62-114f-443c-8d25-b008b0120ae4.jpg',
      description:
        'Una sección especializada para desarrollar muebles modernos y funcionales utilizando melamina.',
      items: [
        'Trabajo y manipulación.',
        'Cortes.',
        'Terminaciones.',
        'Colocación de cantos.',
        'Más de 50 proyectos.',
        'Material complementario.',
      ],
      benefit:
        'Sumá uno de los materiales más utilizados en mobiliario moderno a tus posibilidades.',
    },
    {
      number: 3,
      name: 'Muebles Industriales',
      value: '$18.000',
      included: true,
      image:
        'https://cdn.magicpatterns.com/patterns/generated-images/be3a3478-3c02-4509-b022-ed328c12f584.jpg',
      description:
        'Una colección específica de diseños que combinan madera y metal.',
      items: [
        '300+ diseños y referencias.',
        'Mesas.',
        'Racks.',
        'Escritorios.',
        'Estanterías.',
        'Muebles de alto impacto visual.',
      ],
      benefit:
        'Ampliá tu biblioteca con una estética diferente a la carpintería tradicional.',
    },
    {
      number: 4,
      name: 'Presupuestá y Vendé',
      value: '$14.000',
      included: true,
      image:
        'https://cdn.magicpatterns.com/patterns/generated-images/9fb22901-0387-4304-9741-74eb8ca26f4b.jpg',
      description: 'Una guía para ordenar la parte comercial de tus trabajos.',
      items: [
        'Cómo estructurar un presupuesto.',
        'Cómo explicar un precio.',
        'Cómo responder consultas.',
        'Cómo presentar anticipos.',
        'Cómo contemplar costos importantes.',
      ],
      benefit:
        'Dejá de improvisar también cuando llega el momento de hablar de dinero.',
    },
    {
      number: 5,
      name: 'Iluminación LED',
      value: '$9.000',
      included: true,
      image:
        'https://cdn.magicpatterns.com/patterns/generated-images/d175384b-5e9f-4e30-87ef-52482ebe5dec.jpg',
      description:
        'Recursos para incorporar iluminación LED a diferentes tipos de muebles.',
      items: [
        'Tipos de tiras LED.',
        'Ubicaciones.',
        'Aplicaciones.',
        'Racks.',
        'Placares.',
        'Cocinas.',
        'Errores frecuentes.',
      ],
      benefit:
        'Agregá detalles visuales que pueden transformar completamente la apariencia de un mueble.',
    },
    {
      number: 6,
      name: 'Muebles de Cocina',
      value: '$11.000',
      included: true,
      image:
        'https://cdn.magicpatterns.com/patterns/generated-images/1265f8dc-a523-4043-ac96-d21f6c5c9718.jpg',
      description:
        'Una sección completa dedicada a uno de los tipos de muebles más importantes dentro de la carpintería.',
      items: [
        'Alacenas.',
        'Bajo mesadas.',
        'Módulos.',
        'Cocinas para departamentos.',
        'Diseños en melamina.',
        'Diferentes configuraciones.',
      ],
      benefit:
        'Tené referencias listas cuando quieras desarrollar proyectos de cocina.',
    },
    {
      number: 7,
      name: 'Proyectos de Alto Valor',
      value: '$16.000',
      included: true,
      image:
        'https://cdn.magicpatterns.com/patterns/generated-images/0a1340d3-17ed-4c33-873f-03db9c30fb8a.jpg',
      description:
        'Una selección de proyectos de mayor tamaño, complejidad e impacto visual.',
      items: [
        'Placares.',
        'Vestidores.',
        'Walk-in closets.',
        'Cocinas integrales.',
        'Muebles de bar.',
        'Diseños premium.',
      ],
      benefit:
        'Explorá proyectos más ambiciosos cuando quieras avanzar a otro nivel.',
    },
    {
      number: 8,
      name: 'Calculadora del Carpintero',
      value: '$10.000',
      included: true,
      image:
        'https://cdn.magicpatterns.com/patterns/generated-images/9c339a85-995a-4e4f-a0a3-24e8f7cac49c.jpg',
      description:
        'Una herramienta práctica para ordenar números antes de pasar un presupuesto.',
      items: [
        'Materiales.',
        'Mano de obra.',
        'Gastos.',
        'Margen.',
        'Precio final.',
      ],
      benefit: 'Dejá de preguntarte: “¿Estaré cobrando bien?”',
    },
  ] as Bonus[],
  bonusesTotalValue: '$105.000',
  testimonials: [] as Testimonial[],
  upsell: {
    enabled: false,
    name: '[AGREGAR UPSELL]',
    image: '',
    price: '[AGREGAR PRECIO]',
    description: '[AGREGAR DESCRIPCIÓN]',
    checkoutUrl: '',
  },
  images: {
    workshop:
      'https://cdn.magicpatterns.com/patterns/generated-images/2e644d54-e32e-4da3-b701-5e565d1200b1.jpg',
    plans:
      'https://cdn.magicpatterns.com/patterns/generated-images/c401fd68-1abe-467a-b9ff-8085b737589f.jpg',
    tv: 'https://cdn.magicpatterns.com/patterns/generated-images/3db4f819-6d1c-4209-80de-8eccaf05c05b.jpg',
    kitchen:
      'https://cdn.magicpatterns.com/patterns/generated-images/07c08ec2-4799-455e-8cd8-95b7e6e091ef.jpg',
    closet:
      'https://cdn.magicpatterns.com/patterns/generated-images/61a23653-61a0-4d28-99aa-d3954eb42e70.jpg',
    desk: 'https://cdn.magicpatterns.com/patterns/generated-images/218184da-c575-4a4b-8155-70bb9ec67182.jpg',
  },
}

export const isPlaceholder = (value: string): boolean =>
  !value || value.trim().startsWith('[AGREGAR')

export const checkoutHref = (): string =>
  salesPageData.checkoutUrl && !isPlaceholder(salesPageData.checkoutUrl)
    ? salesPageData.checkoutUrl
    : '#oferta'
